export default {
    productTemplates: [],
    productTemplatesLoading: false,
    setInitialFilters: setInitialFilters,
    filters: setInitialFilters(),
}

function setInitialFilters() {
    return {
        shopOrderNumber: null,
        plannedSendDate__gte: null,
        plannedSendDate__lte: null
    }
}